export default __webpack_public_path__ + "static/media/download_record_processing.cd223e25.gif";